module.exports = "/_next/static/images/cabs-service-2-ee4d6ce8bfc60922a6372796949c946c.webp";